import { LoadingProfiz } from "components/LoadingProfiz";
import { ModalRight } from "components/ModalRight";
import OptionsFilterComponent from "components/OptionsFilterComponent";
import { SearchInput } from "components/SearchInput";
import { useEvent } from "hooks/events";
import { useToast } from "hooks/toast";
import debounce from "lodash.debounce";
import React, { useCallback, useEffect, useState } from "react";
import { api } from "services/api";
import { CardEvent } from "../cardEvent";
import { DetailEvent } from "../detailEvent";

import {
  EventFavorite,
  EventItemProps,
  EventsListItemProps,
  TFilter,
  TPeriod,
} from "../types";

import * as S from "./styles";
import { searchDatalayer } from "utils/pushDataLayer";

const dateFilterProps: TFilter = {
  today: "Hoje",
  tomorrow: "Amanhã",
  thisWeek: "Esta semana",
  thisWekeend: "Neste fim de semana",
  nextWeek: "Próxima semana",
  thisMonth: "Neste mês",
  nextMonth: "Próximo mês",
};

type ResponseProps = {
  data: {
    events: EventsListItemProps[];
  };
};
type ResponseDetailEventProps = {
  data: EventItemProps;
};

type ResponseFavoriteProps = {
  data: { favoriteEvents: EventFavorite[] };
};

export function SavedEvents() {
  const { addToast } = useToast();

  const [dateFilter, setDateFilter] = useState<string[]>([]);
  const [search, setSearch] = useState<string>("");
  const { handleSetSavedEvents, savedEvents, handleSetSelectedEvent } =
    useEvent();
  const [isLoading, setIsLoading] = useState(false);
  const [eventDetail, setEventDetail] = useState<EventItemProps>();
  const [modalOpen, setModalOpen] = useState(false);
  const [inputLoading, setInputLoading] = useState(false);

  useEffect(() => {
    getEventsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFilter]);

  const getEventsData = async () => {
    try {
      setIsLoading(true);

      const favEvent: ResponseFavoriteProps = await api.get(
        "/events/favorites"
      );

      if (
        !favEvent.data.favoriteEvents ||
        favEvent.data.favoriteEvents.length < 1
      ) {
        return handleSetSavedEvents([] as EventsListItemProps[]);
      }
      //deixar a rota meio pronta(lista de favoritos)
      const paramsObj: TFilter = {
        period: dateFilter
          ? dateFilter.toString().replace(new RegExp(",", "g"), "|")
          : "",
        search: search ? search : "",
        favorite: true,
      };
      if (!search || !search.trim()) {
        delete paramsObj.search;
      }
      if (!dateFilter || dateFilter.length < 1) {
        delete paramsObj.period;
      }
      const { data }: ResponseProps = await api.get("/events", {
        params: paramsObj,
      });
      const { events } = data;

      let eventsList = events.map((element) => {
        return { ...element, saved: true };
      });

      //handleSetSavedEvents(events);
      handleSetSavedEvents(eventsList);

      //const response: any = await EventsFavoriteResponse();
      //const eventsList = response.events;
      //handleSetSavedEvents(eventsList);
    } catch (error) {
      addToast({
        title: "Ops!!",
        description: "Ocorreu um erro ao listar os eventos",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const formatSortDate = (listEvents: Array<TPeriod>) => {
    return listEvents.sort(function (elementA, elementB) {
      return elementA.startDate < elementB.startDate ? -1 : 1;
    });
  };

  const handleDetailEvent = async (idxEvent: number) => {
    try {
      setIsLoading(true);

      //deixando requisição...
      const { data }: ResponseDetailEventProps = await api(
        `/events/${idxEvent}`
      );
      //const event = data;

      const favEvent: ResponseFavoriteProps = await api.get(
        "/events/favorites"
      );
      let auxData = favEvent.data.favoriteEvents.find(
        (element) => element.eventId === data.id
      )
        ? { ...data, saved: true }
        : data;

      auxData.periods =
        auxData.periods.length > 1
          ? formatSortDate(auxData.periods)
          : auxData.periods;

      setEventDetail(auxData);
      handleSetSelectedEvent(auxData);
      setModalOpen(true);

      //setEventDetail(data);
      //handleSetSelectedEvent(data);

      //setEventDetail(event as EventItemProps);
      //handleSetSelectedEvent(event as EventItemProps);
    } catch (error) {
      addToast({
        title: "Ops!!",
        description: "Ocorreu um erro ao listar os eventos",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  function handleSearchCancel() {
    setSearch("");
    handleSearchEvents("");
  }

  function handleChange(searchValue: string) {
    setInputLoading(true);
    setSearch(searchValue);
    debounceFn(searchValue, savedEvents);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = useCallback(debounce(handleSearchEvents, 3000), []);

  async function handleSearchEvents(
    event: string,
    eventList?: EventsListItemProps[]
  ) {
    if (event === "" || !event.trim()) {
      getEventsData();
      return;
    }
    try {
      //chamar a api...
      //getEventsData();

      //filtrando os dados...
      const result = eventList?.filter((element) => {
        return (
          element.title.indexOf(event) !== -1 ||
          element.organization.indexOf(event) !== -1
        );
      });
      handleSetSavedEvents(result as EventItemProps[]);
      searchDatalayer({ search_term: event, success: true });
    } catch (error) {
      addToast({
        type: "error",
        title: "Não foi possível realizar a busca.",
      });
    } finally {
      setInputLoading(false);
    }
  }
  const setOptionDate = (newfilter: string) => {
    let arrFilter = dateFilter.filter((element) => element === newfilter);
    return arrFilter.length === 0
      ? setDateFilter([...dateFilter, newfilter])
      : setDateFilter(dateFilter.filter((element) => element !== newfilter));
  };

  return (
    <>
      {isLoading ? (
        <LoadingProfiz isVisible={isLoading} />
      ) : (
        <>
          <ModalRight
            isOpen={modalOpen}
            handleToggleOpen={() => setModalOpen(!modalOpen)}
          >
            {eventDetail && (
              <DetailEvent
                typeView={1}
                handleCloseFunction={() => setModalOpen(!modalOpen)}
              />
            )}
          </ModalRight>

          <S.Content>
            <S.WrapperSearch>
              <SearchInput
                placeholder="Procure por um evento ou treinamento"
                searchValue={search}
                loadingInput={inputLoading}
                onChange={(event) => handleChange(event.target.value)}
                handleCancel={handleSearchCancel}
              />
            </S.WrapperSearch>

            <S.WrapperFilter>
              <OptionsFilterComponent
                data={dateFilterProps}
                optionsSelected={dateFilter}
                handlePressButton={setOptionDate}
              />
            </S.WrapperFilter>

            {!savedEvents || savedEvents.length < 1 ? (
              <S.MessageDiv>
                <h6>Não existem eventos salvos neste momento.</h6>
              </S.MessageDiv>
            ) : (
              <S.ContentPages>
                <S.LeftContent>
                  {savedEvents &&
                    savedEvents.map((element: EventsListItemProps) => {
                      return (
                        <CardEvent
                          element={element}
                          setFunction={handleDetailEvent}
                          key={element.id}
                          typeView={1}
                        />
                      );
                    })}
                </S.LeftContent>
                {/*
              <S.RightContent>
                {eventDetail && <DetailEvent typeView={1} />}
              </S.RightContent> */}
              </S.ContentPages>
            )}
          </S.Content>
        </>
      )}
    </>
  );
}
